import React from 'react';
import { compose, withHandlers, withPropsOnChange } from 'recompose';
import { Div, Flex, Span } from './hocs/withStyles';
import sunnySVG from '../svgs/weather/Sunny.svg';

const FilterBar = compose(
  withPropsOnChange(['destinations', 'filters'], ({ destinations, filters }) => ({
    numDestis: destinations.length,
    directToggleTxt: !filters.nonStop ? 'direct only' : 'all flights',
    minSun: filters.minSunDays
  })),
  withHandlers({
    toggleSunFilter: props => () => {
      const { filters, numDestis, changeMinSunDays } = props;
      const { minSunDays } = filters;
      // don't show 3 suns if there are no results for 2
      if (!numDestis && minSunDays === 2) {
        changeMinSunDays(minSunDays - 1);
        return 0;
      }
      // go from 3 back to 1, or up 1
      const newMin = minSunDays === 3 ? 1 : minSunDays + 1;
      changeMinSunDays(newMin);
    },
    toggleOrder: props => e => {
      const order = e.target.value;
      props.changeOrder(order);
    }
  })
)(props => {
  const {
    minSun,
    directToggleTxt,
    toggleSunFilter,
    toggleOrder,
    toggleNonStopFilter,
    originName,
    hasDirectOnly,
    numDestis,
    order
  } = props;
  return (
    <Div>
      <Flex p={[2, 1]} justifyContent="space-between">
        <Flex>
          <Div p={[1, 2]} bg="white" style={styles.sunToggle} onClick={toggleSunFilter}>
            <img src={sunnySVG} width="25px" alt="sun" />
            <Span p={[0, 1]} css={styles.sunTxt}>
              > {minSun}
            </Span>
          </Div>
          {hasDirectOnly ? null : (
            <Div
              p={[1, 2]}
              bg="white"
              m={[0, 1]}
              css={styles.directToggle}
              onClick={toggleNonStopFilter}
            >
              <Span css={styles.directTxt}>{directToggleTxt}</Span>
            </Div>
          )}
        </Flex>
        {!numDestis ? null : (
          <Div>
            <select defaultValue={order} style={styles.select} onChange={toggleOrder}>
              <option value="price">cheapest first</option>
              <option value="warm">warmest first</option>
              <option value="distance">closest first</option>
            </select>
          </Div>
        )}
      </Flex>
      <Div p={[1, 2]}>
        <strong>{numDestis}</strong> destination{numDestis > 1 ? 's ' : ' '}
        from {originName}:
      </Div>
    </Div>
  );
});

export default FilterBar;

const styles = {
  sunToggle: {
    border: '1px solid #ECECEC',
    borderRadius: '30px',
    cursor: 'pointer'
  },
  sunTxt: {
    position: 'relative',
    top: '-5px'
  },
  directToggle: {
    border: '1px solid #ECECEC',
    borderRadius: '30px',
    cursor: 'pointer',
    width: '80px',
    textAlign: 'center'
  },
  directTxt: {
    position: 'relative',
    top: '3px'
  },
  select: {
    border: '1px solid #ECECEC',
    backgroundColor: 'white',
    height: '34px',
    position: 'relative',
    top: '3px'
  }
};



// WEBPACK FOOTER //
// ./src/components/FilterBar.js